module.exports = __webpack_public_path__ + "img/vrai-benoit.5fb16b6f.jpg";